import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import 'flatpickr/dist/flatpickr.css'
// Connects to data-controller="date-range-picker"
export default class extends Controller {
  static targets = ['input', 'radio', 'label']

  connect() {
    this.flatpickr = flatpickr(this.inputTarget, {
      mode: 'range',
      dateFormat: 'Y-m-d',
      clickOpens: false,
      onOpen: () => {
        this.labelTarget.classList.add('bg-indigo-600', 'text-white')
      },
      onClose: () => {
        if (this.inputTarget.value === "") {
          this.labelTarget.classList.remove('bg-indigo-600', 'text-white')
        }
      },
      onChange: (selectedDates, dateStr, instance) => {
        if (selectedDates.length === 2) {
          //this.labelTarget.textContent = dateStr
          this.radioTarget.value = dateStr
          this.radioTarget.dispatchEvent(new Event('change', { bubbles: true }))
          this.flatpickr.close()
        }
      }
    })

    this.clearCustomDatesBound = this.clearCustomDates.bind(this)
    this.radioName = this.radioTarget.name

    const radios = document.querySelectorAll(`input[name="${this.radioName}"]`)
    radios.forEach(radio => {
      if (radio !== this.radioTarget) {
        radio.addEventListener('change', this.clearCustomDatesBound)
      }
    })
  }

  toggle() {
    this.flatpickr.toggle()
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
    const radios = document.querySelectorAll(`input[name="${this.radioName}"]`)
    radios.forEach(radio => {
      if (radio !== this.radioTarget) {
        radio.removeEventListener('change', this.clearCustomDatesBound)
      }
    })
  }

  clearCustomDates() {
    if (!this.radioTarget.checked) {
      this.inputTarget.value = ""
      this.labelTarget.textContent = "Custom"
      this.labelTarget.classList.remove('bg-indigo-600', 'text-white')
    }
  }
}
